export enum ChartingStatusEnum {
  CHARTING = 'CHARTING',
  NO_CHARTING = 'NO_CHARTING',
}
